import {Colors} from '@/styles';
import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  menuItem: {
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  mobileMenuItem: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    padding: 16,
    paddingVertical: 8,
  },
  mobileMenuItemFocused: {
    backgroundColor: Colors.darkLight,
  },

  menuItemFocused: {
    backgroundColor: 'rgba(250,207,71,0.14)',
    position: 'relative',
  },
  activeAccent: {
    position: 'absolute',
    left: 0,
    top: 6,
    bottom: 6,
    width: 3,
    borderRadius: 99,
    backgroundColor: '#FACF47',
  },

  menuItemText: {
    fontSize: 12,
    color: '#FFF',
    textAlign: 'center',
  },
  mobileMenuItemText: {
    fontSize: 20,
  },

  menuIcon: {
    textAlign: 'center',
    width: 48,
    height: 48,
    padding: 8,
    marginBottom: 8,
    borderRadius: 8,
  },

  mobileMenuIcon: {
    marginBottom: 0,
  },
  fadeBottom: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    height: 60, // Height of the fade effect
  },
  fadeBottomMobile: {
    position: 'absolute',
  },
});
